export class LinkWidgetModel {
    Id: number;
    Url: string;
    Name: string;

    constructor() {
        this.Id = 0;
        this.Url = "";
        this.Name ="";
    }
}